import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import '@/pages/timeline/sections/timeline/timelineSections/certificate/style.css'

import GreyTimer from '@/assets/icons/greyTimer.png'

export default function CertificateClaimed(props: any) {
    const { timeline } = useLocalTranslation();
    return (
        <div className='commonMainCon'>
            <p className='commonp1 mb-[8px] text-[#FD3581] font-bold'>{timeline.certificateSection.certificateClaimed.h1}</p>
            <div className='flex items-center'>
                <img className='w-[13px] mr-[10px]' src={GreyTimer} alt='GreyTimer' />
                <p className='text-[#6F6F6F] commonp1'>{timeline.certificateSection.certificateClaimed.p1}</p>
            </div>
        </div>
    );
};


